var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('pre',{staticClass:"cat"},[_vm._v("["+_vm._s(_vm.cat)+"]")]),_c('router-link',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#' + _vm.slug),expression:"'#' + slug"}],attrs:{"to":"/blog/"}},[_vm._v(" "+_vm._s(_vm.titleBlog)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }